export default __webpack_public_path__ + "static/media/infinite-loader.0108a1f4.svg";